/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Directory_Vibebids_Movement_Outbid_ByInputs */

const en_directory_vibebids_movement_outbid_by = /** @type {(inputs: Directory_Vibebids_Movement_Outbid_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Outbid by $${i?.amount}`)
};

const zh_directory_vibebids_movement_outbid_by = /** @type {(inputs: Directory_Vibebids_Movement_Outbid_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`领先 $${i?.amount}`)
};

/**
* | output |
* | --- |
* | "Outbid by ${amount}" |
*
* @param {Directory_Vibebids_Movement_Outbid_ByInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_movement_outbid_by = /** @type {((inputs: Directory_Vibebids_Movement_Outbid_ByInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Movement_Outbid_ByInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_movement_outbid_by(inputs)
	return zh_directory_vibebids_movement_outbid_by(inputs)
});
export { directory_vibebids_movement_outbid_by as "directory.vibebids.movement_outbid_by" }